import React from 'react';
import atoms from 'ctsutheme/components/atoms';
import { getTableColumns } from 'helpers';
import { FasFile } from 'assets/icons';

const {
  IconButton,
  Tooltip
} = atoms;

const EvntDocClmns = [
  ['sectionHeading', 'string', 'Section Heading', 'left', true],
  ['sectionSubHeading', 'string', 'Section Sub Heading', 'left', true],
  ['documentLinkLabel', 'string', 'Document Link Label', 'left', true],
  ['description', 'string', 'Description', 'left', true],
  ['comments', 'string', 'Comments', 'left', true]
];

const EventDocColumns = [
  ...getTableColumns(EvntDocClmns),
  {
    name: 'docId',
    type: 'string',
    label: 'View Document',
    filterable: false,
    align: 'center',
    renderCell: (data, events) => (
      <Tooltip
        tooltipplacementbottom="true"
        title="View Document"
        aria-label="View Document"
      >
        <IconButton
          key="UserCirbDocs"
          aria-label="View Document"
          color="secondary"
          onClick={() => events[0](data.docId)}
        >
          <FasFile />
        </IconButton>
      </Tooltip>
    )
  }
];

export default EventDocColumns;
